@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

@if (project) {
  <div class="container-fluid accordion-container">
    <div class="container">
      <mat-accordion class="accordion" multi>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="index"></span>
              {{ "pages.projects.project-details.details" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="container my-5">
            <mat-card class="login-card">
              <mat-card-content>
                <form (submit)="updateProject()">
                  <mat-form-field class="full-width" subscriptSizing="dynamic">
                    <mat-label>{{ "generic.title" | translate }}</mat-label>
                    <input matInput [(ngModel)]="projectUpdateModel.title" name="title" required>
                  </mat-form-field>
                  <mat-form-field class="full-width" subscriptSizing="dynamic">
                    <mat-label>{{ "generic.description" | translate }}</mat-label>
                    <textarea matInput rows="1" [(ngModel)]="projectUpdateModel.description" name="description"></textarea>
                  </mat-form-field>
                  <mat-form-field class="full-width" subscriptSizing="dynamic">
                    <mat-label>{{ "projects.fields.obiettivi" | translate }}</mat-label>
                    <textarea matInput rows="1" [(ngModel)]="projectUpdateModel.obiettivi" name="obiettivi"></textarea>
                  </mat-form-field>
                  <mat-form-field class="full-width" subscriptSizing="dynamic">
                    <mat-label>{{ "projects.fields.contesto_clinico_scientifico" | translate }}</mat-label>
                    <textarea matInput rows="1" [(ngModel)]="projectUpdateModel.contesto_clinico_scientifico" name="contesto_clinico_scientifico"></textarea>
                  </mat-form-field>
                  <mat-form-field class="full-width" subscriptSizing="dynamic">
                    <mat-label>{{ "projects.fields.faculty" | translate }}</mat-label>
                    <textarea matInput rows="1" [(ngModel)]="projectUpdateModel.faculty" name="faculty"></textarea>
                  </mat-form-field>
                  <mat-form-field class="full-width" subscriptSizing="dynamic">
                    <mat-label>{{ "projects.fields.board" | translate }}</mat-label>
                    <textarea matInput rows="1" [(ngModel)]="projectUpdateModel.board" name="board"></textarea>
                  </mat-form-field>
                  @for (property of projectProperties; track property) {
                    <div class="full-width">
                      <mat-form-field class="full-width" subscriptSizing="dynamic">
                        <mat-label>{{ property.title }}</mat-label>
                        <mat-select name="property_{{property.id}}" [(ngModel)]="projectUpdateModel.propertyOptions[property.id]">
                          @for (option of property.options; track option) {
                            <mat-option [value]="option.id">
                              {{ option.title }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                  <div class="project-detail-actions">
                    @if (projectUpdateModelIsChanged) {
                      <a mat-button color="warn" (click)="setUpdateProjectModel()">{{ "generic.buttons.cancel-and-back" | translate }}</a>
                    }
                    <button mat-raised-button color="primary" type="submit">
                      <mat-icon>save</mat-icon>
                      {{ "generic.update" | translate }}
                    </button>
                  </div>
                </form>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
}

@if (project && userService.currentOrganizationHasFeature('decision_tables')) {
  <div class="container-fluid accordion-container">
    <div class="container">
      <mat-accordion class="accordion" multi>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="index"></span>
              {{ "pages.projects.component.decision-table" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="my-5">
            <app-all-decision-table [projectId]="project_id" [input_decision_tables]="project?.decision_tables"/>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
}

@if (project && userService.currentOrganizationHasFeature('surveys')) {
  <div class="container-fluid accordion-container"
    >
    <div class="container">
      <mat-accordion class="accordion" multi>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="index"></span>
              {{ 'pages.projects.component.surveys' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="my-5">
            <app-all-surveys [projectId]="project?.id" [input_surveys]="project?.surveys"/>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
}

@if (project && userService.currentOrganizationHasFeature('pico')) {
  <div class="container-fluid accordion-container">
    <div class="container">
      <mat-accordion class="accordion" multi>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="index"></span>
              P.I.C.O.
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="container my-5">
            <mat-card class="login-card">
              <mat-card-content>
                <form>
                  <mat-form-field class="full-width" subscriptSizing="dynamic">
                    <mat-label>{{ 'components.decision-table.pico.patients' | translate }}</mat-label>
                    <input matInput [(ngModel)]=patients name="patients" required />
                  </mat-form-field>
                  <mat-form-field class="full-width" subscriptSizing="dynamic">
                    <mat-label>Intervention</mat-label>
                    <input matInput [(ngModel)]="intervention" name="intervention" required>
                  </mat-form-field>
                  <mat-form-field class="full-width" subscriptSizing="dynamic">
                    <mat-label>{{ 'components.decision-table.pico.comparison'|translate }}</mat-label>
                    <input matInput [(ngModel)]="comparison" name="comparison" required>
                  </mat-form-field>
                  <mat-form-field class="full-width" subscriptSizing="dynamic">
                    <mat-label>{{ 'components.decision-table.pico.outcome'|translate }}</mat-label>
                    <input matInput [(ngModel)]="outcomes" name="outcomes" required>
                  </mat-form-field>
                  <!--                class="row justify-content-center mt-5 mb-3"-->
                  <div class="{{ picoQuestionStatus !== 'ready' ? 'row justify-content-center my-3' : '' }}">
                    @if (projectUpdateModelIsChanged) {
                      <a mat-button color="warn" (click)="setUpdateProjectModel()"
                      class="mr-2">{{ "generic.buttons.cancel-and-back" | translate }}</a>
                    }
                    @if (!picoQuestionStatus) {
                      <button mat-raised-button color="primary"
                        (click)="generatePICOQuestion()">{{ 'components.decision-table.pico.generate-pico-question'|translate }}
                      </button>
                    }
                    @if (picoQuestionStatus === 'pending') {
                      <mat-spinner diameter="40"></mat-spinner>
                    }
                  </div>
                  @if (picoQuestionStatus === 'ready' || !picoQuestionStatus) {
                      <span class="text-muted">{{ 'components.decision-table.pico.generated-pico-search-question'|translate }}</span>
                      <!--                  <input matInput  [(ngModel)]="question" name="question" readonly>-->
                      <div class="box flex-column my-0 pb-0 pt-5 px-3 bordered">
                        <mat-form-field class="full-width">
                          <textarea
                            disabled
                            class="description"
                            matInput rows="2"
                            name="pico_response"
                            [(ngModel)]="question"
                            readonly
                          ></textarea>
                        </mat-form-field>
                      </div>
                  }
                </form>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
}

@if (project  && userService.currentOrganizationHasFeature('literature_review')) {
  <div class="container-fluid accordion-container">
    <div class="container">
      <mat-accordion class="accordion" multi>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="index"></span>
              {{ "pages.projects.component.literature-review" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="container my-5">
            <mat-card class="login-card">
              <!-- <div class="container my-5" *ngIf="keywordsForChipList.length>0"> -->
              <div class="container my-4">
                <mat-card class="login-card">
                  <mat-card-content>
                    <h4 class="mb-3">Keywords</h4>
                    <mat-form-field class="full-width" subscriptSizing="dynamic">
                      <mat-chip-grid #chipList aria-label="Keyword List">
                        @for (keyword of keywordsForChipList; track keyword) {
                          <mat-chip-row
                            color="accent"
                            selected
                            highlighted
                            (removed)="removeKeyword(keyword)"
                            [removable]="true"
                          >
                            {{keyword}}
                            <button matChipRemove [attr.aria-label]="'cancel'">
                              <mat-icon>cancel</mat-icon>
                            </button>
                          </mat-chip-row>
                        }
                        <input
                          placeholder="Add new keyword..."
                          [matChipInputFor]="chipList"
                          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                          (matChipInputTokenEnd)="addKeyword($event)"
                        />
                      </mat-chip-grid>
                    </mat-form-field>
                  </mat-card-content>
                </mat-card>
              </div>
              <mat-card-content>
                <!-- <form> -->
                  <!-- <mat-form-field class="full-width">
                  <mat-label>{{ 'components.decision-table.generated-keywords' | translate }}</mat-label>
                  <input matInput [(ngModel)]="keywords" name="keywords" required/>
                </mat-form-field> -->
                <!--                <mat-form-field class="full-width">-->
                <!--                  <mat-label>Generated bibliography table</mat-label>-->
                <!--                  <textarea matInput [(ngModel)]="biblioTable" name="biblioTable" rows="15" readonly></textarea>-->
              <!--                </mat-form-field>-->
              <div class="row justify-content-center mt-2 mb-2">
                <!--                  <div *ngIf="biblioSearchStatus === 'pending'; else elseBlock">-->
                <!--                    <mat-spinner diameter="40"></mat-spinner>-->
              <!--                  </div>-->
                @if (biblioSearchStatus === 'pending') {
                  <div>
                    <mat-spinner diameter="40"></mat-spinner>
                  </div>
                } @else {
                  <button mat-raised-button color="primary" (click)="searchTermInPublmedEnhanced(true)"
                    >{{ 'components.decision-table.search-on-pubmed-va' | translate }} & Save to Project
                  </button>
                  <!-- DEBUG: Temporary database test button
                  <button mat-stroked-button color="warn" (click)="testDatabaseSaving()" style="margin-left: 10px;">
                    🧪 Test Database
                  </button> -->
                }
            </div>
          <!-- </form> -->
        </mat-card-content>
      </mat-card>
    </div>
    <div class="container my-5">
      @if (searchNumItems === 0 && biblioSearchStatus !== 'pending') {
        <mat-card class="my-5"
          style="background-color: red; color: white;">
          {{ 'pages.projects.component.literature-review.no-items' | translate }}
        </mat-card>
      }
      <div class="process-container">
        @if (processStatus$ | async; as status) {
          <div
            class="status-card"
            [ngClass]="status.status">
            <h3>Request Status: {{ status.status }}</h3>
            <!--              <p>{{status.message}}</p>-->
            <!--              <div *ngIf="status.status === 'completed' && status.result">-->
            <!--                <h4>Result:</h4>-->
            <!--                <pre>{{status.result | json}}</pre>-->
          <!--              </div>-->
          <!--              <div *ngIf="status.status === 'failed'" class="error">-->
          <!--                <p>Error: {{status.message}}</p>-->
          <!--                <button (click)="retryProcess()">Retry</button>-->
        <!--              </div>-->
        <!--              <small>Last updated: {{status.updated_at | date:'medium'}}</small>-->
      </div>
    }
    <!--            <div *ngIf="!isProcessing">-->
    <!--              <button (click)="startProcess()" [disabled]="isProcessing">-->
    <!--                Start Process-->
  <!--              </button>-->
<!--            </div>-->
</div>
<!-- Existing Grade Revisions Display -->
@if (gradeRevisions && gradeRevisions.length > 0) {
  <div class="grade-revisions-section my-5">
    <h4>Existing Grade Revisions ({{ gradeRevisions.length }})</h4>
    <div class="revisions-list">
      @for (revision of gradeRevisions; track trackByRevisionId(i, revision); let i = $index) {
        <mat-card
          class="revision-card mb-3"
          [class.selected]="currentGradeRevision?.id === revision.id">
          <mat-card-content>
            <div class="revision-header-container">
              <div class="revision-header" (click)="loadRevisionDocuments(revision)" style="cursor: pointer; flex: 1;">
                <h5>
                  <span class="revision-number">#{{ i + 1 }}</span>
                  {{ revision.pico_question || revision.title || 'Grade Revision #' + revision.id }}
                </h5>
                <small class="text-muted">
                  {{ revision.created_at | date:'medium' }} - {{ revision.documents?.length || 0 }} documents
                  <mat-icon class="ml-2">arrow_forward</mat-icon>
                </small>
              </div>
              <div class="revision-actions">
                <button mat-icon-button
                  [matMenuTriggerFor]="addDocMenu"
                  (click)="onRevisionSelectForAddDocument(revision, $event)"
                  class="add-document-btn"
                  matTooltip="Add document to this revision"
                  color="accent">
                  <mat-icon>add</mat-icon>
                </button>
                <button mat-icon-button
                  (click)="exportRevisionDocuments(revision)"
                  class="export-revision-btn"
                  matTooltip="Export revision documents to CSV"
                  color="primary">
                  <mat-icon>file_download</mat-icon>
                </button>
                <button mat-icon-button
                  (click)="deleteRevision(revision, $event)"
                  class="delete-revision-btn"
                  matTooltip="Delete revision"
                  color="warn">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
            <!-- Add document menu for this revision -->
            <mat-menu #addDocMenu="matMenu">
              <button mat-menu-item (click)="onClickAddNewDocument('PDF')">
                <mat-icon>picture_as_pdf</mat-icon>
                <span>Add PDF Document</span>
              </button>
              <button mat-menu-item (click)="onClickAddNewDocument('PUBMED')">
                <mat-icon>article</mat-icon>
                <span>Add PubMed Article</span>
              </button>
            </mat-menu>
            @if (revision.description) {
              <p class="revision-description">
                {{ revision.description }}
              </p>
            }
          </mat-card-content>
        </mat-card>
      }
    </div>
  </div>
}
<!-- Search Results Table -->
<div class="mat-elevation-z8">
  <table mat-table [dataSource]="biblioSearchDataSource" matSort>
    <!-- Definizione delle colonne -->
    <ng-container matColumnDef="articleTitle">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Title</mat-header-cell>
      <mat-cell *matCellDef="let article">
        @if (hasDocumentLink(article)) {
          <a
            (click)="openDocumentLink(article)"
            style="cursor: pointer; color: #1976d2; text-decoration: underline;"
            [title]="getLinkTypeDescription(article)">
            {{ article.articleTitle }}
          </a>
        } @else {
          {{ article.articleTitle }}
        }
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="authors">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Authors</mat-header-cell>
      <mat-cell *matCellDef="let article">{{ article.authors }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="year">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Year</mat-header-cell>
      <mat-cell *matCellDef="let article">{{ article.year }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="studyType">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Study Type</mat-header-cell>
      <mat-cell *matCellDef="let article">{{ article.studyType }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="mainOutcome">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Main Outcome</mat-header-cell>
      <mat-cell *matCellDef="let article">{{ article.mainOutcome }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="riskOfBias">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Risk of Bias</mat-header-cell>
      <mat-cell *matCellDef="let article">{{ article.riskOfBias }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="consistency">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Consistency</mat-header-cell>
      <mat-cell *matCellDef="let article">{{ article.consistency }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="precision">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Precision</mat-header-cell>
      <mat-cell *matCellDef="let article">{{ article.precision }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="gradeQuality">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Grade Quality</mat-header-cell>
      <mat-cell *matCellDef="let article">{{ article.gradeQuality }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="remove">
      <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
      <mat-cell *matCellDef="let article">
        <button mat-icon-button
          color="primary"
          (click)="editDocument(article)"
          title="Edit this document"
          class="edit-btn">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button
          color="warn"
          (click)="removeDocument(article)"
          title="Remove this document"
          class="remove-btn">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <!-- Header e righe della tabella -->
    <mat-header-row *matHeaderRowDef="biblioSearchDisplayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: biblioSearchDisplayedColumns;"></mat-row>
  </table>
</div>
<!-- Single Document Processing Spinner -->
@if (isProcessingSingleDocument) {
  <div class="process-container my-4">
    <div class="status-card processing-document">
      <div class="d-flex align-items-center justify-content-center">
        <mat-spinner diameter="40" class="mr-3"></mat-spinner>
        <h4 class="mb-0">Processing document...</h4>
      </div>
    </div>
  </div>
}
</div>
</mat-expansion-panel>
</mat-accordion>
</div>
</div>
}

<div *appShowIfOrganizationHasFeature="'statement-generator'">
  <!-- <div > -->
  @if (project) {
    <div class="container-fluid accordion-container">
      <div class="container">
        <mat-accordion class="accordion" multi>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="index"></span>
                Statement Generator
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="my-5">
              <app-statement-generator
                [projectId]="project_id"
                [projectData]="project"
              [picoData]="{
                population: patients,
                intervention: intervention,
                comparison: comparison,
                outcome: outcomes,
                keywords: keywordsForChipList
              }">
              </app-statement-generator>
            </div>
            <!-- Statement Generations History -->
            <app-statement-generations-list
              [projectId]="project_id"
              [projectData]="project">
            </app-statement-generations-list>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  }

  <!-- Statement Generations History -->
  <!-- <div class="container-fluid accordion-container" *ngIf="project">
  <div class="container">
    <mat-accordion class="accordion" multi>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="index"></span>
            Generated Statements
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="my-5">
          <app-statement-generations-list
            [projectId]="project_id"
            [projectData]="project">
          </app-statement-generations-list>
        </div>

      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div> -->

</div>

<div *appShowIfOrganizationHasFeature="'ckm-simulator'">
  @if (project) {
    <div class="container-fluid accordion-container">
      <div class="container">
        <mat-accordion class="accordion" multi>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="index"></span>
                Simulator
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="my-5">
              <app-ckm-simulation-list [projectId]="project_id"/>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  }

</div>

<div *appShowIfOrganizationHasFeature="'neurx-simulator'">
  @if (project) {
    <div class="container-fluid accordion-container">
      <div class="container">
        <mat-accordion class="accordion" multi>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="index"></span>
                Neurx - Simulator
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-nerf-simulator [projectId]="project_id"/>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  }

</div>

<ng-container *appShowIfOrganizationHasFeature="'automatic_reports'">
  @if (project) {
    <div class="container-fluid accordion-container">
      <div class="container">
        <mat-accordion class="accordion" multi>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="index"></span>
                Automatic reports
              </mat-panel-title>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  }
</ng-container>

<div class="buttons-container container py-4">
  <button class="button-primary float-left" mat-button [routerLink]="['/home']" routerLinkActive="router-link-active">
    <i class="icon-Backward-arrow-small"></i>
    {{ 'generic.buttons.home' | translate }}
  </button>
</div>

<!-- Floating Action Button for Adding Documents - Only show when a grade revision is selected -->
@if (currentGradeRevision) {
  <div class="fab-container"
    style="position: fixed; bottom: 20px; right: 20px; z-index: 9999;">
    <button mat-fab
      color="primary"
      [matMenuTriggerFor]="addDocumentMenu"
      title="Add new document to selected revision">
      <mat-icon>add</mat-icon>
    </button>
    <mat-menu #addDocumentMenu="matMenu">
      <button mat-menu-item (click)="onClickAddNewDocument('PDF')">
        <mat-icon>picture_as_pdf</mat-icon>
        <span>Add PDF Document</span>
      </button>
      <button mat-menu-item (click)="onClickAddNewDocument('PUBMED')">
        <mat-icon>article</mat-icon>
        <span>Add PubMed Article</span>
      </button>
    </mat-menu>
  </div>
}

